import { getFromStore, setToStore } from '@/data/local-store';
import { stepMods, stepsContent } from '@/data/steps';
import { localStoreFormDataName, localStoreStepName } from '@/models/local-store';
import { Mod } from '@/models/mod';
import { NavigationDirection } from '@/models/navigation-direction';
import { Steps } from '@/models/steps';
import store from '.';

let notСhosenTimeout: NodeJS.Timeout;

const dataFromStore = getFromStore(localStoreFormDataName) || {
  [Steps.MOD]: null,
  [Steps.ROASTIN]: null,
  [Steps.FLAVOUR]: null,
  [Steps.AFTERTASTE]: null,
  [Steps.AROMA]: null,
  [Steps.ACIDITY]: null,
  [Steps.AMOUNT]: null,
  [Steps.LABEL]: null,
  [Steps.SUMMARY]: null,
  [Steps.PORTION]: null,
};

export default {
  steps: {
    state: {
      step: getFromStore(localStoreStepName) || Steps.START,
      steps: stepMods[(dataFromStore[Steps.MOD] as Mod) || 'debutant'],
      stepsContent: stepsContent,
      notСhosen: false,
    },
    mutations: {
      navigateToDirection: (
        state: { step: Steps; steps: Steps[], stepsContent: any },
        direction: NavigationDirection
      ) => {
        const currentStepIndex = state.steps.indexOf(state.step);
        switch (direction) {
          case NavigationDirection.PREVIEW:
            store.commit('notСhosen', false);
            state.step = currentStepIndex
              ? state.steps[currentStepIndex - 1]
              : state.step;
            break;
          case NavigationDirection.NEXT: {
            const formData = store.getters.getFormData;
            if (formData[state.step] || state.step === Steps.START || !state.stepsContent[state.step].required) {
              state.step =
                currentStepIndex < state.steps.length - 1
                  ? state.steps[currentStepIndex + 1]
                  : state.step;
            } else {
              if (currentStepIndex === state.steps.length - 1) {
                store.dispatch('sendForm');
              } else {
                store.commit('notСhosen');
              }
            }
            break;
          }
        }
        setToStore(state.step, localStoreStepName);
      },
      navigateToStep: (state: { step: Steps; steps: Steps[], stepsContent: any }, step: Steps) => {
        const prevStepIndex = state.steps.indexOf(step) - 1;
        const formData = store.getters.getFormData;
        if (
          step === Steps.START ||
          state.steps[prevStepIndex] === Steps.START ||
          formData[state.steps[prevStepIndex]] ||
          (state.stepsContent[prevStepIndex] && !state.stepsContent[prevStepIndex].required)
        ) {
          state.step = step;
        } else {
          store.commit('notСhosen');
        }
      },
      notСhosen: (state: { notСhosen: boolean }, value = true) => {
        state.notСhosen = value;
        notСhosenTimeout && clearTimeout(notСhosenTimeout);
        notСhosenTimeout = setTimeout(() => {
          if (state.notСhosen) {
            state.notСhosen = false;
          }
        }, 3000);
      },

      setStepsMod: (state: { step: Steps; steps: Steps[] }, mod: Mod) => {
        if (state.steps.length !== stepMods[mod].length) {
          store.commit('resetData', mod);
          state.steps = stepMods[mod];
        }
      },

      setStepList: (state: { stepsContent: any }, data: {
        step: string,
        list: []
      }) => {
        state.stepsContent[data.step]['list'] = data.list;
      },

      setStepSkip: (state: { stepsContent: any }, data: {
        step: string,
        skip: boolean
      }) => {
        state.stepsContent[data.step]['required'] = !data.skip;
      }
    },
    getters: {
      getActiveStep: (state: { step: Steps }) => {
        return state.step;
      },
      getSteps: (state: { steps: Steps[] }) => {
        return state.steps;
      },
      notСhosen: (state: { notСhosen: boolean }) => {
        return state.notСhosen;
      },

      stepsContent: (state: { stepsContent: any }) => {
        return state.stepsContent;
      },

      stepContent: (state: { stepsContent: any }) => (stepName: string) => {
        return state.stepsContent[stepName];
      }
    },
  },
};
